import { updateDeviceScanStatus } from 'reducers/inventoryReducer';
import {
  updatePowerOptionsStatus,
  updateRemoteControlSessionStatus,
  updateRemoteSupportSessionStatus,
  updateWakeOnLanStatus,
} from 'reducers/remoteReducer';
import {
  updateConnectorSyncStatus,
  updateDeviceManagedStatus,
  updateDomainSyncStatus,
} from '../reducers/enrollmentReducer';
import { updatePatchScanDeviceStatus } from 'reducers/patchReducer';

const toInt = (value, fieldName) => {
  const n = Number(value);
  if (!Number.isInteger(n)) {
    console.warn(`Invalid ${fieldName}:`, value);
    return null;
  }
  return n;
};

const handlers = {
  INVENTORY_EVENT: {
    DEVICE_SCAN_STATUS: (DATA) => {
      const deviceId = toInt(DATA.deviceId, 'deviceId');
      if (deviceId === null) return;

      updateDeviceScanStatus({
        ...DATA,
        deviceId,
        scanStatus: DATA.status,
      });
    },
  },

  RC_EVENT: {
    RC_SESSION_STATUS: ({ deviceId, status }) => {
      const id = toInt(deviceId, 'deviceId');
      if (id === null) return;

      updateRemoteControlSessionStatus(id, status);
    },

    RS_SESSION_STATUS: ({ sessionId, status }) => {
      const id = toInt(sessionId, 'sessionId');
      if (id === null) return;

      updateRemoteSupportSessionStatus(id, status);
    },

    WAKE_ON_LAN_STATUS: ({ deviceId, status, remarks }) => {
      const id = toInt(deviceId, 'deviceId');
      if (id === null) return;

      updateWakeOnLanStatus(id, status, remarks);
    },

    POWER_OPTIONS_STATUS: ({ deviceId, status, remarks, powerOption }) => {
      const id = toInt(deviceId, 'deviceId');
      if (id === null) return;

      updatePowerOptionsStatus(id, powerOption, status, remarks);
    },
  },

  ENROLLMENT_EVENT: {
    MANAGED_STATUS: ({ id, status }) => {
      const parsedId = toInt(id, 'id');
      if (parsedId === null) return;

      updateDeviceManagedStatus(parsedId, status);
    },

    CONNECTOR_SYNC_STATUS: ({ id, status }) => {
      const parsedId = toInt(id, 'id');
      if (parsedId === null) return;

      updateConnectorSyncStatus(parsedId, status);
    },

    DOMAIN_SYNC_STATUS: ({ id, status }) => {
      const parsedId = toInt(id, 'id');
      if (parsedId === null) return;

      updateDomainSyncStatus(parsedId, status);
    },
  },

  PATCH_EVENT: {
    DEVICE_SCAN_STATUS: (DATA) => {
      const deviceId = toInt(DATA.deviceId, 'deviceId');
      if (deviceId === null) return;

      updatePatchScanDeviceStatus({
        ...DATA,
        deviceId,
        scanStatus: DATA.status,
      });
    },
  },
};

const handleWmsMessage = (message) => {
  let parsed;

  try {
    parsed = JSON.parse(message);
  } catch (err) {
    console.error('Invalid JSON message:', message);
    return;
  }

  const { TYPE, SUBJECT, DATA } = parsed;

  const typeHandler = handlers[TYPE];
  if (!typeHandler) {
    console.warn('Unhandled TYPE:', TYPE);
    return;
  }

  const subjectHandler = typeHandler[SUBJECT];
  if (!subjectHandler) {
    console.warn('Unhandled SUBJECT:', SUBJECT, 'for TYPE:', TYPE);
    return;
  }

  subjectHandler(DATA);
};

export default handleWmsMessage;